var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMortgage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5891E2",
  d: "M10.76 1.333H4.98C2.72 1.333 1.2 2.92 1.2 5.28v5.446c0 2.354 1.52 3.94 3.78 3.94h5.78c2.26 0 3.773-1.586 3.773-3.94V5.28c0-2.36-1.513-3.947-3.773-3.947"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  fillRule: "evenodd",
  d: "M5.375 11.331a.8.8 0 0 0 .6-.251l4.974-4.968a.853.853 0 0 0 0-1.2.843.843 0 0 0-1.19 0L4.785 9.88a.85.85 0 0 0 0 1.199.8.8 0 0 0 .59.251m4.132-.85a.846.846 0 1 0 1.692.009.846.846 0 0 0-1.692-.01",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#5891E2",
  d: "M5.372 4.666a.83.83 0 0 1 .828.829.83.83 0 0 1-.828.838.84.84 0 0 1-.838-.838c0-.458.38-.829.838-.829"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M5.385 4.666c.465 0 .842.377.842.842a.844.844 0 0 1-.842.851.85.85 0 0 1-.851-.851.85.85 0 0 1 .851-.842"
})));
export default SvgMortgage;